<template>
	<div>
        <input type="text" class="input-text" placeholder="输入手机号" @input="input" v-model='phone' maxlength="11"/>
        <div class="input-con hbox">
            <input type="text" class="input-text flex" placeholder="验证码" v-model='code'/>
            <button class="code" v-bind:class="{active: phoneRight}" v-if="sendCode && !reSendCode" @click="send">发送验证码</button>
            <span class="code active" v-if="!sendCode && !reSendCode">{{codeNum}}S</span>
            <button class="code active" v-if="reSendCode" @click='send'>重新发送</button>
        </div>
		<div id="captcha"></div>
        <button class="g-btn1" @click="click">下一步</button>
	</div>
</template>
<script>
	import {phoneReg} from '../../../common/libs/common.js';
	import api from '../../../common/libs/api.js';

	export default{
	  name: 'SmsCode',
	  props: {
	    title: {
	      type: String,
	      default: '',
	      required: true
	    }
	  },
	  data() {
	    return {
	      phone: '',
	      phoneRight: false,
	      code: '',
	      codeNum: 60,
	      sendCode: true,
	      reSendCode: false,
	      smsContent: {}
	    }
	  },
	  methods: {
	    click() {
	      if (this.phone.length == 0) {

	        this.$store.dispatch('toast', {title: '请输入手机号码', show: true});
	        return;
	      }
	      if (!this.phoneRight) {

				this.$store.dispatch('toast', {title: '请输入正确格式的11位手机号', show: true});
				return;
			}
			if (this.code.length == 0) {

	        this.$store.dispatch('toast', {title: '请输入正确的验证码', show: true});
	        return;
	      }

	      this.$emit('sonClick', this.phone, this.code);
	    },
	    input() {
	      if (phoneReg.test(this.phone)) {

	        this.phoneRight = true;
	      } else {

	        this.phoneRight = false;
	      }
	    },
	    timer() {
	      let vm = this;

	      let timer = setInterval(function() {
	        if (vm.codeNum == 1) {
	          clearInterval(timer);
	          timer = null;
	          vm.codeNum = 60;
	          vm.reSendCode = true;
	        } else {
	          vm.codeNum--;
	        }
	      }, 1000)
	    },
	    send() {
	      let vm = this;

	      if (!this.phoneRight) {
	        return;
	      }
	      this.reSendCode = false;
	      this.sendCode = false;
	      this.timer();

				api.apiMethod.codeSend.post({
					phone: this.phone,
					code_type: 4
				}).then(res => {

				if (res.data.code == 0) {
					vm.smsContent = res.data.data;
				} else {
					vm.$store.dispatch('toast', {title: res.data.msg, show: true});
				}
			})
			// let data = {
			// 	phone_code: '86',
			// 	phone: this.phone
			// };
			// var params = {
			// data,
			// success: function (res) {
			// 	if (res.errcode == 11021) {
			// 		// 需要展示滑块
			// 		// 滑块验证的逻辑是滑动验证通过后，SDK再次调用之前的方法，与后端交互，通过success回调返回这次操作的结果，故需要将方法名和之前的入参数据作为showSlide的参数。
			// 		var param = {
			// 			slideCallback: 'sendSMSCodeLogin', // 滑动验证通过时执行方法名，（即触发滑块的原方法，例如：登录（loginSms），获取验证码（sendSmsCodeLogin），校验旧手机（checkPhone））
			// 			slideParams: params, // 前端滑动验证通过时执行方法名的参数（例如手机号，验证码,success和fail等等）
			// 			failCallback: function (error) {
			// 				vm.$store.dispatch('toast', {title: error.errmsg, show: true});
			// 			} // 方法名出错
			// 		}
			// 		// 展示滑块
			// 		TAL_UC.showSlide(param)
			// 		return
			// 	} else if (res.errcode == 0){
			// 		vm.$store.dispatch('toast', {title: '已发送验证码到您的手机，请注意查收', show: true});
			// 	} else {
			// 	vm.$store.dispatch('toast', {title: res.errmsg, show: true});
			// 	}
			// },
			// fail: function (error) {
			// 	vm.$store.dispatch('toast', {title: error.errmsg, show: true});
			// }
			// }
			// TAL_UC.sendSMSCodeLogin(params)
		}
		},
		created() {

	  }
	}
</script>


// WEBPACK FOOTER //
// src/components/public/smsCode/SmsCode.vue